<template>
  <div>
    <div class="card custom-card">
      <div class="card-header border-bottom">
        <h3 class="card-title">Reports</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div v-for="file in reportFiles" :key="file.id" class="col-xl-3 col-md-6 col-sm-6 my-1">
            <div class="card m-0 p-0 border">
              <div class="d-flex align-items-center px-3 pt-3">
                <label v-if="showSelectBox" class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" name="filename-checkbox" value="option2" @click="onCheckBoxClick(file)">
                  <span class="custom-control-label"><span style="display: none;">Checkbox for {{ file.filename }}</span></span>
                </label>
                <base-dropdown 
                  title=""
                  title-tag="a"
                  title-classes="nav-link"
                  class="fa fa-ellipsis-v float-end ms-auto nav-item">
                  <li class="nav-link">
                    <a href="#" @click.prevent="downloadFile(file)" class="nav-item dropdown-item">Download</a>
                  </li>
                  <li v-if="hasSelection" class="nav-link">
                    <a href="#" @click.prevent="downloadSelected()" class="nav-item dropdown-item">Download Selected</a>
                  </li>
                </base-dropdown>
              </div>
              <div class="card-body pt-0 text-center">
                <div class="file-icon">
                  <a href="#" @click.prevent="downloadFile(file)">
                    <img :src="fileThumbnail(file)" alt="img" class="br-7">
                  </a>
                </div>
                <h6 class="mb-1 font-weight-semibold text-capitalize">{{ file.filename }}</h6>
                <span class="text-muted">{{file.sizeText}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseDropdown from '../../components/BaseDropdown.vue';
import { getReportFiles, getDownloadFile } from 'src/modules/adminActions';
import { isNullOrEmpty } from 'src/modules/utils';

export default {
  name: 'ReportFiles',
  components: {
    BaseDropdown,
  },
  data() {
    return {
      surveyUrlId: null,
      instance: null,
      reportFiles: [],
      hasSelection: false,
      decimals: 2,
      kbPerByte: 0.0009765625,
    };
  },
  computed: {
    hasFiles() {
      return this.reportFiles.length > 0;
    },
    surveyId() {
      return this.$route.params.surveyId;
    },
    urlId() {
      return this.$route.params.urlId;
    },
    showSelectBox() {
      return this.reportFiles.length > 1;
    },
  },
  methods: {
    initialize() {
      this.getFiles();
    },
    fileThumbnail(file) {
      let name = file.filename.toLowerCase();
      return name.indexOf("pdf") > -1 ? "img/pdf-file.png"
        : name.indexOf("docx") > -1 || name.indexOf("doc") > -1 ? "img/word-file.png"
        : "img/generic-file.png";
    },
    getFiles(reportRequest) {
      reportRequest = reportRequest || {
        surveyUrlId: this.urlId,
        hspSurveyId: this.surveyId
      };

      getReportFiles(reportRequest)
        .then(response => {
          this.reportFiles = response.data.fileList;
          this.reportFiles.forEach(x => {
            x.isChecked = false;
            x.filePath = "/reports/" + x.parentDirectory + "/" + x.filename;
            x.sizeText = this.toFileSizeText(x.size);
          });
        });
    },
    toFileSizeText(size) {
      let description = " Bytes";
      let sizeNum = size;
      if (sizeNum >= 1.024e9) {
        description = " GB";
        sizeNum *= 1e-6 * this.kbPerByte;
      }
      else if (sizeNum >= 1.024e6) {
        description = " MB";
        sizeNum *= 1e-3 * this.kbPerByte;
      }
      else if (sizeNum >= 1024) {
        description = " KB";
        sizeNum *= this.kbPerByte;
      }

      return sizeNum.toFixed(this.decimals) + description;
    },
    async downloadFile(fileInfo) {
      await this.downloadFiles([fileInfo]);
    },
    async downloadFiles(files) {
      if (isNullOrEmpty(files)) {
        return;
      }

      for (const file of files) {
        const response = await getDownloadFile({url: file.filePath});
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = file.filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    async downloadSelected() {
      const selected = this.reportFiles.filter(x => x.isChecked);
      if (selected.length === 0) {
        return;
      }

      await this.downloadFiles(selected);
    },
    onCheckBoxClick(fileInfo) {
      let found = this.reportFiles.find(x => x.id === fileInfo.id);
      if (!found) {
        return;
      }

      found.isChecked = !found.isChecked;
      this.hasSelection = this.reportFiles.filter(x => x.isChecked).length > 0;
    },
  },
  created() {
    this.initialize();
  },
};
</script>

<style scoped>
.float-end {
  float: right !important;
}

.ms-auto {
  margin-left: auto !important;
}

.file-icon img {
  height: 86px;
  width: 70px;
}

.br-7 {
  border-radius: 7px;
}
</style>